import { render, staticRenderFns } from "./EditDeleteIssueButton.vue?vue&type=template&id=638398ed&scoped=true"
import script from "./EditDeleteIssueButton.vue?vue&type=script&lang=js"
export * from "./EditDeleteIssueButton.vue?vue&type=script&lang=js"
import style0 from "./EditDeleteIssueButton.vue?vue&type=style&index=0&id=638398ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638398ed",
  null
  
)

export default component.exports